<template>
  <BaseWeb :logo-img="logoPhoto"
           :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum"
           class="many_recruit_btn" :download-path="downloadPath" :one-word="oneWord" :tow-word="towWord"></BaseWeb>
</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
  name: "wardrobeDiary",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
    return{
      logoPhoto:require('../assets/wardrobeImg/logo.jpg'),
      appPhotoArr:[
        {id:1,photo:require('../assets/wardrobeImg/one.png')},
        {id:2,photo:require('../assets/wardrobeImg/tow.png')},
        {id:3,photo:require('../assets/wardrobeImg/three.png')},
        {id:4,photo:require('../assets/wardrobeImg/four.png')},
      ],
      appName:'衣橱日记',
      companyName:'厦门乐榜网络科技有限公司',
      icpNum:'闽ICP备18007063号-6',
      downloadPath:'http://apk.hotbuybuy.com/cmjz_oppo_100.apk',
      oneWord:'衣橱日记：衣橱里衣服满满，却不知道每天该穿什么？打开衣橱日记，寻找穿衣灵感吧！',
      towWord:'衣橱里各种款式都有，却不知道约会怎么搭配？打开衣橱日记，参考时尚达人怎么搭配的吧！'
    }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:rgb(252,90,103);
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobeDiary.vue